<div class="container-fluid bg-beige services-page-banner">
    <div class="row">
        <div class="col-sm-12 pt-3 pb-3">
            <h1 class="text-center h1-shadow">OUR SERVICES</h1>
        </div>
    </div>
</div>

<div class="container-fluid bg-beige pb-5">
    <div class="retro-thin mb-3"></div>
    <div class="retro-thick"></div>
</div>

<div class="container-fluid bg-beige">
    <div class="row">
        <div class="col-12 text-center p-large">
            <p>We guarantee reliable, expert plumbing services<br>and a commitment to your satisfaction.</p>
        </div>
    </div>
    <div class="row ribbon-pt">
        <div class="col-12 ribbon-image">
            <a class="a-nostyle" href="tel:5875681541">
                <img src="../assets/site-theme/OldFaithfulRibbon.svg" alt="Red Ribbon with Purple Outline">
                <div class="ribbon-text">CALL US 587-568-1541</div>
            </a> 
        </div>
    </div>
</div>

<div class="container-fluid bg-beige pt-5">
    <div class="retro-thick mb-3"></div>
    <div class="retro-thin"></div>
</div>

<div class="container-fluid bg-beige pt-4 pb-4 pl-5 pr-5">
    <div class="row">
        <!--LEFT CONTENT BEGINS-->
        <div class="col-lg-2 col-md-3 blue-box no-padding">
            <h1>- - - - -</h1>
            <p class="p-3">Reach out for a FREE consultation for any of your plumbing projects.</p>
            <div class="col-sm-12 d-flex justify-content-center pt-9 pb-9 mb-tablet-pt mb-pt">
                <a routerLink="/contact" href="/contact"><button type="button" class="btn btn-red">CONTACT US</button></a>
            </div>
            <h2 class="mb-tablet-pt mb-pt">Normal Hours</h2>
            <hr>
            <p>Week Days:</p>
            <br>
            <p>7:00 AM - 5:00 PM</p>
            <br>
            <br>
            <p>Weekends:</p>
            <br>
            <p>Closed</p>
            <hr class="pb-5">
        </div>
        <!--RIGHT CONTENT BEGINS-->
        <div class="col-lg-10 col-md-9 mb-tablet-pl mb-pt">
            <div class="blue-box p-3 ml-8 mr-8">
                <p class="p-large">THE NAME YOU TRUST FOR TIMELESS PLUMBING</p>
            </div>
            <!--SERVICES START-->
            <div class="row pt-5">
                <div class="col-lg-6 pl-9 pr-9 mb-tablet-pl"> <!--RENO-->
                    <div class="content-break-top"></div>
                    <h2 class="pt-2 pb-4">Plumbing Reno &amp; Remodeling</h2>
                    <br>
                    <h3 class="pb-2">Update your home's plumbing system.</h3>
                    <div class="content-break-bottom"></div>
                    <div class="row pt-3">
                        <div class="col-md-3">
                            <picture>
                                <source srcset="../assets/site-theme/PlumbReno.svg">
                                <img class="service-icon-small" src="../assets/site-theme/PlumbReno.svg" alt="Plunger and Wrench Icon">
                            </picture>
                        </div>
                        <div class="col-md-9 pl-4 mb-pt-icon">
                            <p>Our plumbing renovation services focus on updating your home’s plumbing system. We assess your existing setup and provide solutions for installing new fixtures and rerouting pipes to enhance functionality and efficiency. Our experienced team is dedicated to quality workmanship, ensuring your renovation meets your needs. Contact us to learn more about how we can assist you.</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 pl-9 pr-9 mb-tablet-pt mb-tablet-pl mb-pt"> <!--DRAIN CLEAN-->
                    <div class="content-break-top"></div>
                    <h2 class="pt-2 pb-4">Drain Cleaning</h2>
                    <br>
                    <h3 class="pb-2">Clear clogs and buildup.</h3>
                    <div class="content-break-bottom"></div>
                    <div class="row pt-3">
                        <div class="col-md-3">
                            <picture>
                                <source srcset="../assets/site-theme/PipeClean.svg">
                                <img class="service-icon-small" src="../assets/site-theme/PipeClean.svg" alt="Clean Pipe Icon">
                            </picture>
                        </div>
                        <div class="col-md-9 pl-4 mb-pt-icon">
                            <p>Our drain cleaning services ensure your plumbing runs smoothly by effectively clearing clogs and buildup. Using advanced tools and techniques, we tackle slow drains and persistent blockages. Regular drain cleaning helps prevent future issues, keeping your system healthy. Contact us for reliable and efficient drain cleaning solutions.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row pt-5">
                <div class="col-lg-6 pl-9 pr-9 mb-tablet-pt mb-tablet-pl mb-pt"> <!--LEAK-->
                    <div class="content-break-top"></div>
                    <h2 class="pt-2 pb-4">Leak Repair</h2>
                    <br>
                    <h3 class="pb-2">Fix leaks and malfunctioning fixtures.</h3>
                    <div class="content-break-bottom"></div>
                    <div class="row pt-3">
                        <div class="col-md-3">
                            <picture>
                                <source srcset="../assets/site-theme/LeakRepair.svg">
                                <img class="service-icon-small" src="../assets/site-theme/LeakRepair.svg" alt="Leaking Faucet Icon">
                            </picture>
                        </div>
                        <div class="col-md-9 pl-4 mb-pt-icon">
                            <p>Our service calls offer quick and reliable plumbing assistance for issues like leaks, clogs, and malfunctioning fixtures. Our skilled technicians diagnose and resolve problems efficiently, ensuring your satisfaction. With transparent pricing and expert advice, you can count on us to restore your plumbing system. Contact us to schedule your service call today!</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 pl-9 pr-9 mb-tablet-pt mb-tablet-pl mb-pt"> <!--HOT WATER TANK-->
                    <div class="content-break-top"></div>
                    <h2 class="pt-2 pb-4">Hot Water Tank Replacement</h2>
                    <br>
                    <h3 class="pb-2">Ensure reliable hot water in your home.</h3>
                    <div class="content-break-bottom"></div>
                    <div class="row pt-3">
                        <div class="col-md-3">
                            <picture>
                                <source srcset="../assets/site-theme/HotWaterTank.svg">
                                <img class="service-icon-small" src="../assets/site-theme/HotWaterTank.svg" alt="Hot Water Tank Icon">
                            </picture>
                        </div>
                        <div class="col-md-9 pl-4 mb-pt-icon">
                            <p>We provide professional hot water tank installation to ensure reliable hot water in your home. Our experienced team helps you choose the right tank and handles all plumbing connections for optimal performance and efficiency. Trust us for a smooth installation process. Contact us to learn more!</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid bg-beige pt-3">
    <div class="retro-thick mb-3"></div>
    <div class="retro-thin"></div>
</div>

<div class="container-fluid bg-beige">
    <a routerLink="/contact" href="/contact">
        <button type="button" class="btn-lg-red text-center">
            <p>Contact us for a FREE CONSULTATION today</p>
        </button>
    </a>
</div>

<div class="container-fluid bg-beige pb-5 mb-for-footer">
    <div class="retro-thin mb-3"></div>
    <div class="retro-thick"></div>
</div>
